import React from 'react';
import { Dimensions } from 'react-native';
import {
  VictoryBar,
  VictoryChart,
  VictoryLabel,
  VictoryTheme,
  VictoryAxis,
} from 'victory';
import * as GlobalVariableContext from '../config/GlobalVariableContext';

export const App = () => {
  const variables = GlobalVariableContext.useValues();
  const expenses = variables.EXPENSES;

  const data =
    expenses && expenses.length > 0
      ? expenses
      : [
          { name: 'Finance Expense', value: 0 },
          { name: 'Operating Expense', value: 0 },
          { name: 'Employee Expense', value: 0 },
          { name: 'Product Expense', value: 0 },
        ];

  const colors = ['#FFC000', '#5a45ff', '#8FD400', '#1FB9FA'];

  // Maximum değeri belirle ve ona göre tickValues ayarla
  const maxValue = Math.max(...data.map(d => d.value)); // Verideki en yüksek değeri bul
  const tickValues =
    maxValue > 50
      ? undefined // Eğer en yüksek değer 50'den büyükse Victory'nin default davranışını kullan
      : [0, 10, 20, 30, 40, 50]; // Eğer en yüksek değer 50'den küçükse sabit aralıklar kullan

  return (
    <VictoryChart
      width={Dimensions.get('window').width}
      height={Dimensions.get('window').width / 1.9}
      domainPadding={40}
      theme={VictoryTheme.material}
      padding={{ top: 20, bottom: 60, left: 54, right: 20 }}
    >
      <VictoryAxis
        tickValues={[1, 2, 3, 4]}
        tickFormat={data.map(d => d.name)}
        style={{
          tickLabels: { fill: 'white', fontSize: 8, textAnchor: 'middle' },
          grid: { stroke: 'transparent' },
        }}
      />
      <VictoryAxis
        dependentAxis
        tickValues={tickValues}
        tickFormat={x => `${x}%`}
        style={{
          axis: { stroke: '#756f6a' },
          axisLabel: { fontSize: 20, padding: 0 },
          grid: { stroke: 'grey', strokeWidth: 0.5, strokeDasharray: 0.1 },
          ticks: { stroke: 'transparent', size: 0 },
          tickLabels: { fontSize: 9, padding: 2, fontWeight: 900 },
        }}
      />
      <VictoryBar
        data={data}
        x="name"
        y="value"
        alignment="middle"
        barWidth={40}
        labels={({ datum }) => `${datum.value}%`}
        labelComponent={
          <VictoryLabel
            dy={8}
            textAnchor="middle"
            backgroundStyle={{ fill: 'transparent' }}
            backgroundPadding={4}
          />
        }
        style={{
          labels: { fill: '#000000', fontSize: 9, fontWeight: 750 },
          data: {
            fill: ({ index }) => colors[index % colors.length],
          },
        }}
      />
    </VictoryChart>
  );
};
